jQuery(() => {
	jQuery('.no-js').removeClass('no-js');
});